
import { useState } from 'react';

const VideoGallerySection = () => {
  const [activeVideo, setActiveVideo] = useState<number | null>(null);

  const videos = [
    {
      id: 1,
      thumbnail: 'https://public.readdy.ai/ai/img_res/4d6a282fc208ffc975fbe4a3e89b8f4b.jpg',
      title: 'Ceramic Coating Application',
      category: 'Protection'
    },
    {
      id: 2,
      thumbnail: 'https://readdy.ai/api/search-image?query=professional%20paint%20correction%20polishing%20on%20red%20luxury%20car%20hood%20with%20orbital%20polisher%20creating%20mirror%20finish%20in%20dark%20studio%20with%20blue%20neon%20ambient%20lighting%20automotive%20detailing&width=400&height=300&seq=vid2&orientation=landscape',
      title: 'Paint Correction Magic',
      category: 'Restoration'
    },
    {
      id: 3,
      thumbnail: 'https://readdy.ai/api/search-image?query=luxury%20car%20interior%20detailing%20leather%20seats%20being%20cleaned%20and%20conditioned%20with%20professional%20equipment%20in%20high%20end%20detailing%20studio%20blue%20ambient%20lighting%20premium%20automotive%20care&width=400&height=300&seq=vid3&orientation=landscape',
      title: 'Interior Transformation',
      category: 'Interior'
    },
    {
      id: 4,
      thumbnail: 'https://readdy.ai/api/search-image?query=black%20luxury%20SUV%20full%20exterior%20wash%20with%20foam%20cannon%20creating%20thick%20white%20foam%20in%20professional%20car%20wash%20bay%20with%20blue%20LED%20strip%20lights%20dramatic%20automotive%20photography&width=400&height=300&seq=vid4&orientation=landscape',
      title: 'Premium Foam Wash',
      category: 'Exterior'
    },
    {
      id: 5,
      thumbnail: 'https://readdy.ai/api/search-image?query=engine%20bay%20detailing%20cleaning%20luxury%20car%20engine%20compartment%20with%20steam%20cleaner%20professional%20automotive%20detailing%20blue%20ambient%20lighting%20high%20end%20car%20care%20service&width=400&height=300&seq=vid5&orientation=landscape',
      title: 'Engine Bay Revival',
      category: 'Engine'
    },
    {
      id: 6,
      thumbnail: 'https://readdy.ai/api/search-image?query=wheel%20and%20tire%20detailing%20cleaning%20luxury%20car%20chrome%20wheels%20with%20specialized%20brushes%20and%20products%20in%20professional%20studio%20blue%20neon%20lighting%20automotive%20photography&width=400&height=300&seq=vid6&orientation=landscape',
      title: 'Wheel Perfection',
      category: 'Wheels'
    }
  ];

  return (
    <section id="gallery" className="py-32 bg-gradient-to-b from-primary-dark to-primary-black relative overflow-hidden">
      {/* Enhanced background effects */}
      <div className="absolute inset-0">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 25% 25%, rgba(0, 212, 255, 0.15) 0%, transparent 50%),
                           radial-gradient(circle at 75% 75%, rgba(0, 102, 255, 0.15) 0%, transparent 50%)`
        }}></div>
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-blue/50 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-blue/50 to-transparent"></div>
        
        {/* Floating glow orbs */}
        <div className="absolute top-1/4 right-1/4 w-64 h-64 bg-primary-blue/15 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 left-1/4 w-48 h-48 bg-primary-deepblue/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1.5s' }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 mb-6">
            <div className="w-12 h-px bg-gradient-to-r from-transparent to-primary-blue"></div>
            <span className="text-primary-blue font-inter text-sm font-semibold tracking-widest uppercase" style={{ textShadow: '0 0 20px rgba(0, 212, 255, 0.8)' }}>
              Our Work
            </span>
            <div className="w-12 h-px bg-gradient-to-l from-transparent to-primary-blue"></div>
          </div>
          <h2 className="text-5xl md:text-6xl font-orbitron font-bold text-white mb-4" style={{ textShadow: '0 0 40px rgba(0, 212, 255, 0.7)' }}>
            VIDEO GALLERY
          </h2>
          <p className="text-gray-400 font-inter text-lg max-w-2xl mx-auto">
            Watch our expert team transform vehicles into showroom masterpieces
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {videos.map((video, index) => (
            <div
              key={video.id}
              className="group relative rounded-2xl overflow-hidden cursor-pointer transform transition-all duration-500 hover:-translate-y-3 hover:scale-[1.02]"
              style={{ 
                boxShadow: '0 0 30px rgba(0, 212, 255, 0.3)',
                animationDelay: `${index * 0.1}s`
              }}
              onClick={() => setActiveVideo(activeVideo === video.id ? null : video.id)}
            >
              {/* Glow border effect */}
              <div className="absolute inset-0 rounded-2xl border-2 border-primary-blue/40 group-hover:border-primary-blue transition-colors duration-500 z-20 pointer-events-none" style={{ boxShadow: 'inset 0 0 20px rgba(0, 212, 255, 0.2)' }}></div>
              
              {/* Thumbnail */}
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-primary-black via-primary-black/50 to-transparent opacity-80 group-hover:opacity-60 transition-opacity duration-500"></div>
                
                {/* Blue glow overlay on hover */}
                <div className="absolute inset-0 bg-primary-blue/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                {/* Play button */}
                <div className="absolute inset-0 flex items-center justify-center z-10">
                  <div 
                    className="w-20 h-20 flex items-center justify-center rounded-full bg-primary-blue/20 backdrop-blur-sm border-2 border-primary-blue transform transition-all duration-500 group-hover:scale-110 group-hover:bg-primary-blue/40"
                    style={{ boxShadow: '0 0 40px rgba(0, 212, 255, 0.6)' }}
                  >
                    <i className="ri-play-fill text-4xl text-white ml-1"></i>
                  </div>
                </div>

                {/* Category badge */}
                <div className="absolute top-4 left-4 z-10">
                  <span 
                    className="px-4 py-1.5 bg-primary-blue/30 backdrop-blur-sm text-primary-blue font-inter text-xs font-bold tracking-wider uppercase rounded-full border border-primary-blue/50"
                    style={{ textShadow: '0 0 10px rgba(0, 212, 255, 0.8)' }}
                  >
                    {video.category}
                  </span>
                </div>

                {/* Title */}
                <div className="absolute bottom-0 left-0 right-0 p-6 z-10">
                  <h3 className="text-xl font-inter font-bold text-white group-hover:text-primary-blue transition-colors duration-300" style={{ textShadow: '0 0 20px rgba(0, 0, 0, 0.8)' }}>
                    {video.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View More Button */}
        <div className="text-center mt-16">
          <button 
            className="group relative px-10 py-4 bg-transparent border-2 border-primary-blue text-primary-blue font-inter font-bold text-lg rounded-xl transition-all duration-500 hover:text-white whitespace-nowrap cursor-pointer overflow-hidden"
            style={{ boxShadow: '0 0 25px rgba(0, 212, 255, 0.4)' }}
          >
            <span className="relative z-10 flex items-center gap-3">
              <i className="ri-youtube-line text-2xl"></i>
              VIEW MORE ON YOUTUBE
            </span>
            <div className="absolute inset-0 bg-gradient-to-r from-primary-blue to-primary-deepblue opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
          </button>
        </div>
      </div>
    </section>
  );
};

export default VideoGallerySection;
